<template>
  <login-page-frame>
    <div :style="{ minHeight: minheight }" class="adminlogin_form">
      <slot></slot>
    </div>
  </login-page-frame>
</template>

<script>
import LoginPageFrame from '@/components/login/LoginPageFrame.vue'

export default {
  components: { LoginPageFrame },
  props: {
    minheight: {
      type: String,
      default: '520px'
    }
  }
}
</script>

<style lang="less" scoped>
.adminlogin_form {
  position: relative;
  box-sizing: border-box;
  width: 430px;
  max-width: 100%;
  margin: 0;
  padding: 40px 36px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 16px 56px rgba(37, 80, 130, .09), 0 2px 8px rgba(37, 80, 130, .025);
}

// 旧表单的操作区使用绝对定位；随内容排布，避免四字段表单与按钮重叠
.adminlogin_form ::v-deep .loginForm > .el-form-item:last-child {
  position: static !important;
  width: 100% !important;
  margin-top: 24px;
  margin-bottom: 0 !important;
}

.adminlogin_form ::v-deep .agrement {
  height: auto;
  min-height: 20px;
}

.adminlogin_form ::v-deep .agrement .el-checkbox {
  display: flex;
  align-items: flex-start;
  max-width: 100%;
  white-space: normal;
}

.adminlogin_form ::v-deep .agrement .el-checkbox__input {
  flex: none;
  margin-top: 3px;
}

.adminlogin_form ::v-deep .agrement .el-checkbox__label {
  min-width: 0;
  white-space: normal;
  line-height: 20px;
}

@media (max-width: 400px) {
  .adminlogin_form {
    padding: 34px 22px;
  }
}
</style>
